import PropTypes from "prop-types"
import React, { useEffect, useRef } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

const SidebarContent = props => {
  const ref = useRef()
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      // if (matchingMenuItem) {
      //   activateParentDropdown(matchingMenuItem)
      // }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  // function scrollElement(item) {
  //   if (item) {
  //     const currentPosition = item.offsetTop
  //     if (currentPosition > window.innerHeight) {
  //       ref.current.getScrollElement().scrollTop = currentPosition - 300
  //     }
  //   }
  // }

  // function activateParentDropdown(item) {
  //   item.classList.add("active")
  //   const parent = item.parentElement
  //   const parent2El = parent.childNodes[1]
  //   if (parent2El && parent2El.id !== "side-menu") {
  //     parent2El.classList.add("mm-show")
  //   }

  //   if (parent) {
  //     parent.classList.add("mm-active")
  //     const parent2 = parent.parentElement

  //     if (parent2) {
  //       parent2.classList.add("mm-show") // ul tag

  //       const parent3 = parent2.parentElement // li tag

  //       if (parent3) {
  //         parent3.classList.add("mm-active") // li
  //         parent3.childNodes[0].classList.add("mm-active") //a
  //         const parent4 = parent3.parentElement // ul
  //         if (parent4) {
  //           parent4.classList.add("mm-show") // ul
  //           const parent5 = parent4.parentElement
  //           if (parent5) {
  //             parent5.classList.add("mm-show") // li
  //             parent5.childNodes[0].classList.add("mm-active") // a tag
  //           }
  //         }
  //       }
  //     }
  //     scrollElement(item)
  //     return false
  //   }
  //   scrollElement(item)
  //   return false
  // }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        {JSON.parse(localStorage.getItem("authUser")).user.Designation === "Administrate" ? (
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              <li className="menu-title">{props.t("QUOTES")} </li>
              <li>
                <Link to="/quote/todays-quotes" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Today's Quotes")}</span>
                </Link>
              </li>
              <li>
                <Link to="/quote/ready-quotes" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Ready Quotes")}</span>
                </Link>
              </li>
              <li>
                <Link to="/quote/all-quotes" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("All Quotes")}</span>
                </Link>
              </li>
              <li>
                <Link to="/quote/convert-to-order" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Convert To Order")}</span>
                </Link>
              </li>
              <li className="menu-title">{props.t("ORDERS")} </li>
              <li>
                <Link to="/order/todays-orders" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Today's Orders")}</span>
                </Link>
              </li>
              <li>
                <Link to="/order/ready-orders" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Ready Orders")}</span>
                </Link>
              </li>
              <li>
                <Link to="/order/all-orders" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("All Orders")}</span>
                </Link>
              </li>
              <li>
                <Link to="/order/orders-with-price-zero" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Orders With Price 0$")}</span>
                </Link>
              </li>
              <li>
                <Link to="/order/orders-with-price" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Orders With Price")}</span>
                </Link>
              </li>
              <li className="menu-title">{props.t("VECTORS")} </li>
              <li>
                <Link to="/vector/todays-vectors" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Today's Vector")}</span>
                </Link>
              </li>
              <li>
                <Link to="/vector/ready-vectors" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Ready Vector")}</span>
                </Link>
              </li>
              <li>
                <Link to="/vector/all-vectors" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("All Vectors")}</span>
                </Link>
              </li>
              <li>
                <Link to="/vector/vector-with-price-zero" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Vectors With Price 0$")}</span>
                </Link>
              </li>
              <li>
                <Link to="/vector/vector-with-price" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Vectors With Price")}</span>
                </Link>
              </li>
              <li className="menu-title">{props.t("CUSTOMERS")} </li>
              <li>
                <Link to="/customers" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Customers")}</span>
                </Link>
              </li>
              <li>
                <Link to="/all-customers" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("All Customers")}</span>
                </Link>
              </li>
              <li>
                <Link to="/designers-progress" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Designers Progress")}</span>
                </Link>
              </li>
              <li>
                <Link to="/sales-man-progress" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Sales Man Progress")}</span>
                </Link>
              </li>
              <li>
                <Link to="/orders-report" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Orders Report")}</span>
                </Link>
              </li>
              <li>
                <Link to="/customers-report" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Customers Report")}</span>
                </Link>
              </li>
              <li>
                <Link to="/company-report" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Company Report")}</span>
                </Link>
              </li>
              <li className="menu-title">{props.t("EMPLOYEE")} </li>
              <li>
                <Link to="/employee" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Employee")}</span>
                </Link>
              </li>
            </ul>
          </div>
        ) : JSON.parse(localStorage.getItem("authUser")).user.Designation === "sales" ? (
         <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              
              <li className="menu-title">{props.t("CUSTOMERS")} </li>
              <li>
                <Link to="/customers" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Customers")}</span>
                </Link>
              </li>
              <li>
                <Link to="/sales-man-progress" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Sales Man Progress")}</span>
                </Link>
              </li>
              
             
            </ul>
          </div>
        ) : (
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              <li className="menu-title">{props.t("QUOTES")} </li>
              <li>
                <Link to="/user/view-quotes" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Quote Record")}</span>
                </Link>
              </li>
              <li>
                <Link to="/user/create-quote" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Place Quote")}</span>
                </Link>
              </li>
              <li className="menu-title">{props.t("ORDERS")} </li>
              <li>
                <Link to="/user/view-orders" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Order Record")}</span>
                </Link>
              </li>
              <li>
                <Link to="/user/create-order" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Place Order")}</span>
                </Link>
              </li>
              <li className="menu-title">{props.t("VECTORS")} </li>
              <li>
                <Link to="/user/view-vectors" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Vector Record")}</span>
                </Link>
              </li>
              <li>
                <Link to="/user/create-vector" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Place Vector")}</span>
                </Link>
              </li>

              <li className="menu-title">{props.t("INVOICE")} </li>
              <li>
                <Link to="/user/invoice-history" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Invoice History")}</span>
                </Link>
              </li>
              <li>
                <Link to="/user/generate-invoice" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Generate Invoice")}</span>
                </Link>
              </li>




            </ul>
          </div>
        )}

      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
